import {
  Conditional,
  RequestServiceStepIndicator
} from '@cat-ecom/pcc-components';
import styles from '../request-equipment-service.module.scss';
import { RequestServiceDateTimeProps } from '../types';
import RequestEquipmentServicePreferredDate from '../request-equipment-service-preferred-date';

const RequestEquipmentServiceDateTime = ({
  isMobile,
  classname,
  tabs
}: RequestServiceDateTimeProps) => {
  return (
    <div
      className={`${styles['border-top-bottom']}
        ${styles['divider']}
        ${styles['preferred-date-wrapper']}`}
    >
      <RequestEquipmentServicePreferredDate tabs={tabs} isMobile={isMobile} />
      <Conditional test={isMobile}>
        <div className={'mt-md-4 pt-md-3'}>
          <RequestServiceStepIndicator classname={classname} />
        </div>
      </Conditional>
    </div>
  );
};
export default RequestEquipmentServiceDateTime;
